import styled from 'styled-components';

// Some notices come from multiline textareas (e.g. the zone calendar text), so line breaks are kept.
export const Notice = styled.p`
  border-left: 4px solid #f8e600;
  padding: 0.25rem 0 0.25rem 0.75rem;
  font-weight: 600;
  white-space: pre-line;
`;
